import React from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import { I18nProvider } from "./i18n"

let root

let swRegistered = false
function registerServiceWorker() {
  if (swRegistered) return
  swRegistered = true

  if (!("serviceWorker" in navigator)) return
  if (!window.isSecureContext) return

  navigator.serviceWorker.register("/service-worker.js").catch(() => {
    // Best-effort. PWA installability should not break the app.
  })
}

function mount() {
  const element = document.getElementById("yano-app")
  if (!element) return

  if (!root) {
    root = createRoot(element)
  }

  root.render(<I18nProvider><App /></I18nProvider>)
}

document.addEventListener("turbo:load", () => {
  registerServiceWorker()
  mount()
})
